import { FC, HTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import cn from 'classnames';

import { useOffersRetrieveQuery } from 'entities/Brand';
import { EditPostPageState, PostForm } from 'entities/Post';
import { useBackButton } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';
import { OverlayLoader, Page, PageTitle } from 'shared/ui';

interface IEditPostProps extends HTMLAttributes<HTMLDivElement> {}

export const EditPost: FC<IEditPostProps> = ({ className, ...props }) => {
	const { t } = useTranslation();

	const { plannerPostId } = useParams<{ plannerPostId: string }>();

	const [params] = useSearchParams();
	const offerId = params.get('offerId');
	const { data: offer, isLoading } = useOffersRetrieveQuery(offerId || '', { skip: !offerId });

	const [pageState, setPageState] = useState<EditPostPageState>(EditPostPageState.PUBLISHING_SETTINGS);

	useBackButton(
		pageState === EditPostPageState.PUBLISHING_SETTINGS
			? offer?.brand.uuid
				? `/${EMainRoutes.BRAND}/${offer?.brand.uuid}`
				: `/${EMainRoutes.CATALOG}`
			: undefined,
		pageState === EditPostPageState.POST_EDITOR ? () => setPageState(EditPostPageState.PUBLISHING_SETTINGS) : undefined,
	);

	const contentMap = {
		[EditPostPageState.POST_EDITOR]: {
			title: t('Редактор поста'),
			subTitle: t('Создайте новый текст, или добавьте свою иллюстрацию'),
		},
		[EditPostPageState.PUBLISHING_SETTINGS]: {
			title: t('Настройки публикации'),
			subTitle: t('Выберите канал и время публикации'),
		},
	};

	return (
		<Page {...props} className={cn(className)}>
			{isLoading && <OverlayLoader />}

			<PageTitle subtitle={contentMap[pageState].subTitle}>{contentMap[pageState].title}</PageTitle>

			{!!offer && (
				<PostForm offer={offer} plannerPostId={plannerPostId} pageState={pageState} setPageState={setPageState} />
			)}
		</Page>
	);
};

export default EditPost;
